import React from "react";

//Import utils
import { Button } from "react-bootstrap";
import { useTranslation } from "react-i18next";

export default function Product(props) {

    // let refactored = props.img.slice(0, props.img.length-4);
    let url = props.type === "product" ? "/images/results/products/" + props.img  : "/images/results/texture/model/" + props.img.replace('.jpg','.jpg');
    const { t } = useTranslation('common');
    let image = process.env.PUBLIC_URL + url;

    return(
        <div className="product-container">
            <h5 className="product-title">{t(props.title)}</h5>
            <div className="img-wrapper">
            	<img src={image} alt="" width="300" height="300"/>
            </div>
            <p className="product-details-comp">{t(props.shadeName)} <span>{props.shadeCode}</span></p>
            <Button href={props.link} target="_blank" className="product-button">+ {t('Shop Now')}</Button>
        </div>
    );
}